import {
    GET_BANNERS_SUCCESS, GET_BANNERS_LOADING, GET_BANNERS_ERROR,
    ADD_BANNER_SUCCESS, ADD_BANNER_LOADING, ADD_BANNER_ERROR,
    UPDATE_BANNER_SUCCESS, UPDATE_BANNER_LOADING, UPDATE_BANNER_ERROR,
    DELETE_BANNER_SUCCESS, DELETE_BANNER_LOADING, DELETE_BANNER_ERROR,
    GET_HERO_BANNER_ELIGIBLE_SERIES_SUCCESS, GET_HERO_BANNER_ELIGIBLE_SERIES_LOADING, GET_HERO_BANNER_ELIGIBLE_SERIES_ERROR,
    UPDATE_HERO_BANNER_ELIGIBILITY_SUCCESS, UPDATE_HERO_BANNER_ELIGIBILITY_LOADING, UPDATE_HERO_BANNER_ELIGIBILITY_ERROR,
    REORDER_BANNERS_SUCCESS, REORDER_BANNERS_LOADING, REORDER_BANNERS_ERROR,
    GET_BANNERS_WITH_SERIES_SUCCESS, GET_BANNERS_WITH_SERIES_LOADING, GET_BANNERS_WITH_SERIES_ERROR,
    UPLOAD_BANNER_IMAGE_SUCCESS, UPLOAD_BANNER_IMAGE_LOADING, UPLOAD_BANNER_IMAGE_ERROR
} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ""
};

export const GetBannersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BANNERS_LOADING: return { ...state, loading: action.data };
        case GET_BANNERS_SUCCESS: return { ...state, payload: action.data, loading: false };
        case GET_BANNERS_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const AddBannerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_BANNER_LOADING: return { ...state, loading: action.data };
        case ADD_BANNER_SUCCESS: return { ...state, payload: action.data, loading: false };
        case ADD_BANNER_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const UpdateBannerReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_BANNER_LOADING: return { ...state, loading: action.data };
        case UPDATE_BANNER_SUCCESS: return { ...state, payload: action.data, loading: false };
        case UPDATE_BANNER_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const DeleteBannerReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_BANNER_LOADING: return { ...state, loading: action.data };
        case DELETE_BANNER_SUCCESS: return { ...state, payload: action.data, loading: false };
        case DELETE_BANNER_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const GetHeroBannerEligibleSeriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HERO_BANNER_ELIGIBLE_SERIES_LOADING: return { ...state, loading: action.data };
        case GET_HERO_BANNER_ELIGIBLE_SERIES_SUCCESS: return { ...state, payload: action.data, loading: false };
        case GET_HERO_BANNER_ELIGIBLE_SERIES_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const UpdateHeroBannerEligibilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_HERO_BANNER_ELIGIBILITY_LOADING: return { ...state, loading: action.data };
        case UPDATE_HERO_BANNER_ELIGIBILITY_SUCCESS: return { ...state, payload: action.data, loading: false };
        case UPDATE_HERO_BANNER_ELIGIBILITY_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const ReorderBannersReducer = (state = initialState, action) => {
    switch (action.type) {
        case REORDER_BANNERS_LOADING: return { ...state, loading: action.data };
        case REORDER_BANNERS_SUCCESS: return { ...state, payload: action.data, loading: false };
        case REORDER_BANNERS_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const GetBannersWithSeriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BANNERS_WITH_SERIES_LOADING: return { ...state, loading: action.data };
        case GET_BANNERS_WITH_SERIES_SUCCESS: return { ...state, payload: action.data, loading: false };
        case GET_BANNERS_WITH_SERIES_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const UploadBannerImageReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_BANNER_IMAGE_LOADING: return { ...state, loading: action.data };
        case UPLOAD_BANNER_IMAGE_SUCCESS: return { ...state, payload: action.data, loading: false };
        case UPLOAD_BANNER_IMAGE_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};
